<template>
  <div>
    <div v-for="(text, value) in $t('rating.items')" class="d-flex rating-label" :key="'label-' + value">
      <div class="flex-grow-0">
        <b-link class="info-icon" v-b-popover.click.blur.top="$t('rating.info.' + value)">i</b-link>
      </div>
      <div class="rating-label-text text-nowrap">{{ text }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RatingLabels'
}
</script>
<style lang="scss" scoped>
  @import '../scss/config';

  .rating-label {
    line-height: 1.5rem;
    padding: 0.625rem 0;
  }

  .info-icon {
    display: block;
    border: 1px solid $body-color;
    border-radius: 50%;
    padding: 0 0.5rem;
    line-height: 1.25rem;
    text-decoration: none !important;
  }

  .rating-label-text{
    padding: 0 0.5rem;
    font-family: $font-family-sans-serif;
  }
</style>
